import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from './ui/select';
import { ScrollArea } from './ui/scroll-area';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { toast } from './ui/use-toast';
import { API_BASE_URL } from '../config';
import { FUNCTION_NAMES } from '../constants';
import { fetchWithRetry } from '../utils/tourUtils';

const ContractorSelector = ({ value, onChange, hideAdd = false }) => {
  const [contractors, setContractors] = useState([]);
  const [newContractor, setNewContractor] = useState({ nameHe: '', nameEn: '' });
  const [loading, setLoading] = useState(false);

  const fetchContractors = async () => {
    const res = await fetchWithRetry({
      url: `${API_BASE_URL}/api/post`,
      data: {
        function_name: FUNCTION_NAMES.PRISMA,
        operation: 'contractor.findMany',
        payload: {},
      },
      label: 'fetch contractors',
    });
    setContractors(res);
  };

  const addContractor = async () => {
    if (!newContractor.nameHe || !newContractor.nameEn) return;
    setLoading(true);
    try {
      await fetchWithRetry({
        url: `${API_BASE_URL}/api/post`,
        data: {
          function_name: FUNCTION_NAMES.PRISMA,
          operation: 'contractor.create',
          payload: newContractor,
        },
        label: 'create contractor',
        throwError: true,
      });
      toast({ title: 'קבלן נוסף בהצלחה' });
      setNewContractor({ nameHe: '', nameEn: '' });
      fetchContractors();
    } catch (err) {
      toast({ title: 'שגיאה', description: 'בעיה בהוספת קבלן', variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContractors();
  }, []);

  return (
    <div className="space-y-2">
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger>
          <SelectValue placeholder="בחר קבלן" />
        </SelectTrigger>
        <SelectContent className="max-h-60">
          <ScrollArea className="h-full">
            {contractors.map(c => (
              <SelectItem key={c.id} value={c.id}>
                {c.nameHe} / {c.nameEn}
              </SelectItem>
            ))}
          </ScrollArea>
        </SelectContent>
      </Select>
      {!hideAdd && (
        <div className="flex gap-2">
          <Input
            placeholder="שם קבלן בעברית"
            value={newContractor.nameHe}
            onChange={e => setNewContractor({ ...newContractor, nameHe: e.target.value })}
          />
          <Input
            placeholder="שם קבלן באנגלית"
            value={newContractor.nameEn}
            onChange={e => setNewContractor({ ...newContractor, nameEn: e.target.value })}
          />

          <Button onClick={addContractor} disabled={loading}>
            הוסף קבלן
          </Button>
        </div>
      )}
    </div>
  );
};

export default ContractorSelector;
